import React, { Suspense, lazy } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom"; // no BrowserRouter here
import Layout from "./Layout";
import { usePageMeta } from "./seo";

import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import Projects from "./pages/Projects";
import About from "./pages/About";

// Split out, unlike the routes above: BlogPost pulls in react-markdown and
// react-syntax-highlighter with its Prism grammars, which together were the
// largest thing in the bundle — and none of it is reachable from any other
// route. Everyone landing on the home page was downloading and parsing a
// markdown renderer to look at a page with no markdown on it.
const BlogPost = lazy(() => import("./pages/BlogPost"));

// Deliberately identical to BlogPost's own isLoading branch: the chunk arriving
// and the markdown arriving are two waits in a row, and showing the same thing
// for both makes them read as one instead of flickering between two spinners.
function PostLoading() {
  return (
    <section
      className="section"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
      }}
    >
      <div className="pixel-loader"></div>
      <p style={{ marginTop: "20px", color: "var(--accent)" }}>Loading post...</p>
    </section>
  );
}

function NotFound() {
  // Netlify's SPA rewrite serves this with a 200, so the only way to keep junk
  // URLs out of the index is to say so explicitly.
  const { pathname } = useLocation();
  usePageMeta({
    title: "Page not found",
    description: "That page does not exist.",
    path: pathname,
    noindex: true,
  });

  return (
    <section className="section" style={{ textAlign: "center" }}>
      <h3>404</h3>
      <p style={{ margin: "10px 0 20px" }}>
        Are you trying to hack me?  Aint u ? Kindly go back to home page and try again.
      </p>
      <Link to="/" className="pixel-button">
        Back to Home
      </Link>
    </section>
  );
}

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        {/* allow any sub‑path under /blog to render a post; BlogList still wins for
            the exact "/blog" URL because it is a more specific match */}
        <Route
          path="/blog/*"
          element={
            <Suspense fallback={<PostLoading />}>
              <BlogPost />
            </Suspense>
          }
        />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default App;
